"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/People/PersonCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _useOrgAccount = require('shared/hooks/useOrgAccount');

var _Avatar = require('web/components/Avatar');
var _format = require('web/screens/Directory/PatientTable/format');
var _people = require('./people');













/* One person over the People table (screen 04), the patient panel's pattern:
 * read only, apart from Change account role. Escape closes it, unless a
 * dialog is open on top. */
const PersonCard = ({ person, orgName, onChangeRole, onRemove, removeBlocker, onClose }) => {
  _react.useEffect.call(void 0, () => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !document.querySelector('.blm-modal')) onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const name = _people.personName.call(void 0, person)
  return (
    _react2.default.createElement('aside', { className: "dir-drawer account-person-card" , role: "dialog", 'aria-label': `${name} details`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
      , _react2.default.createElement('div', { className: "account-person-card--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        , _react2.default.createElement(_Avatar.UserAvatar, { userKey: person.UserKey, size: 40, noOnlineIndicator: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )
        , _react2.default.createElement('div', { className: "account-person-card--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
          , _react2.default.createElement('div', { className: "account-person-card--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}},  name )
          , _react2.default.createElement('div', { className: "account-person-card--email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}},  person.Email )
        )
        , _react2.default.createElement('button', { type: "button", className: "dir-drawer--close", 'aria-label': "Close", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
          , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-cross-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} )
        )
      )
      , _react2.default.createElement('div', { className: "account-person-card--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Account")
        , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
          , _react2.default.createElement('div', { className: "directory-page--info-section--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
            , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
              , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Account role" )
              , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}},  person.AccountRole ? _useOrgAccount.ACCOUNT_ROLE_LABELS[person.AccountRole] : 'None' )
            )
            , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
              , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "Managed by" )
              , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}},  _people.managedLabels.call(void 0, person).join(', ') || '—' )
            )
            , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
              , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Last active" )
              , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}},  _format.formatActivity.call(void 0, _nullishCoalesce(person.LastActive, () => ( undefined))) )
            )
          )
        )
        ,  onChangeRole && (
          _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
            , _react2.default.createElement('button', { type: "button", className: "dir-link account-person-card--action" , onClick: onChangeRole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Change account role"  )
          )
        )
        ,  onRemove && (
          _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
            , _react2.default.createElement('button', {
              type: "button",
              className: "dir-link account-person-card--action account-person-card--remove"  ,
              disabled: !!removeBlocker,
              'aria-describedby': removeBlocker ? 'account-person-remove-why' : undefined,
              onClick: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
, "Remove from account"

            )
            ,  removeBlocker && _react2.default.createElement('p', { id: "account-person-remove-why", className: "account-person-card--why", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}},  removeBlocker ) 
          )
        )
        , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}, "Organizations")
        , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
          , _react2.default.createElement('div', { className: "directory-page--info-section--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
            ,  person.Memberships.map(m => (
              _react2.default.createElement('div', { key: m.OrgKey, className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
                , _react2.default.createElement('span', { className: "name", title: orgName(m.OrgKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}},  orgName(m.OrgKey) )
                , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}},  _useOrgAccount.ORG_ROLE_LABELS[m.Role] , " · "  ,  _people.membershipLabel.call(void 0, m) )
              )
            ))
            ,  person.Memberships.length === 0 && _react2.default.createElement('span', { className: "dir-cell--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, "No organizations" ) 
          )
        )
      )
    )
  )
}

exports. default = PersonCard
